import { render, staticRenderFns } from "./DashboardWidgetROE.vue?vue&type=template&id=c895191a&"
import script from "./DashboardWidgetROE.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetROE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports